import { useTranslation } from 'react-i18next';
import { useIsHongKongIp } from '../../../hooks/useIsHongKongIp';

export default function HeroSection() {
  const { t } = useTranslation();
  const { canShowRestrictedContent } = useIsHongKongIp();

  const openLiveChat = () => {
    window.LiveChatWidget?.call('maximize');
  };

  return (
    <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-24 overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{
          backgroundImage: `url('/img/a306208f22151b8d0dd420707121c5f9.jpg')`,
        }}
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-orange-400 to-yellow-400 bg-clip-text text-transparent">
            {t('contact.contactUs')}
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
            {t('contact.getInTouch')}
          </p>

          {/* Quick Contact Stats */}
          <div className={`grid grid-cols-1 ${canShowRestrictedContent ? 'md:grid-cols-3' : 'md:grid-cols-2'} gap-8 mt-16`}>
            {/* Live Chat is unavailable for HK / US visitors. */}
            {canShowRestrictedContent && (
              <button
                type="button"
                onClick={openLiveChat}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300 text-center"
              >
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold mb-2">{t('contact.247Sup')}</h3>
                <p className="text-gray-300">{t('contact.247Sup.desc')}</p>
              </button>
            )}

            {/* Direct Line */}
            <a
              href="tel:+85230083082"
              className="block bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300"
            >
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">{t('contact.dirLine')}</h3>
              <p className="text-gray-300">{t('contact.dirLine.desc')}</p>
            </a>

            {/* Go to Map */}
            <a
              href="#map-section"
              className="block bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300"
            >
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">{t('contact.hkOffice')}</h3>
              <p className="text-gray-300">{t('contact.hkOffice.desc')}</p>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}